import { z } from "zod";

export const schema = z.object({
  authenticity_token: z.string(),
  _method: z.literal("put"),
  form_user_achievement_collection: z.object({
    user_achievements_attributes: z.array(
      z
        .object({
          name: z.string(),
          year: z.union([z.string(), z.number()]).nullable(),
          month: z.union([z.string(), z.number()]).nullable(),
        })
        .check((ctx) => {
          const { name, year, month } = ctx.value;
          if (!name && (month || year)) {
            ctx.issues.push({
              code: "custom",
              path: ["name"],
              message: "受賞名を入力してください。",
              input: ctx.value,
            });
          }
          if (year && !month) {
            ctx.issues.push({
              code: "custom",
              path: ["month"],
              message: "有効な月を入力してください。",
              input: ctx.value,
            });
          }
          if (!year && month) {
            ctx.issues.push({
              code: "custom",
              path: ["year"],
              message: "有効な年を入力してください。",
              input: ctx.value,
            });
          }
        }),
    ),
  }),
});

export type InputProps = z.input<typeof schema>;
